import { functions } from '@/assets/script/functions'
const subCategories = {
  state: {
    subCategories: [],
    selectedSubCategories: []
  },
  mutations: {
    setSubCategoriesState(state, subCategories){
      state.subCategories = subCategories
    },
    setSelectedSubCatState(state, subCategories){
      state.selectedSubCategories = subCategories
    }
  },
  actions: {
    // Called on click setSubFilter() from SubCategoryFilter.vue
    // Sets all second layer categories
    setSelectedSubCategory({state, commit, dispatch}, name){
      const subCategories = state.selectedSubCategories
      const isFiltered = subCategories.indexOf(name);
      if(isFiltered == -1)
        subCategories.push(name)
      else
        subCategories.splice(isFiltered, 1)
      commit('setSelectedSubCatState', subCategories)
      dispatch('setFilteredRecipes')
    },
    getSubCategories({commit, state, dispatch}, recipes){
      const subCategories = []
      let selectedSubCats = state.selectedSubCategories
      recipes.map(recipe => {
        // Get all categories from selected category
        return recipe.Categories
      }).forEach(categories => {
        categories.forEach(category => {
          // If category is not in first layer of categories
          // if(this.state.currentCategoryStore.currentCategory.categories.indexOf(category.Name) == -1)
            // Add it to sub categories
            subCategories.push(category)
        })
      })
      const uniqueSubCategories = functions.getUnique(subCategories, 'Name')

      selectedSubCats.filter(selectedSubCategory => {
        const visibleSubCategories = uniqueSubCategories.find(unique => {
          return unique.Name == selectedSubCategory
        })
        // If we don't find selected sub category in available sub categories
        if(visibleSubCategories == undefined)
          // Remove that shiet
          dispatch('setSelectedSubCategory', selectedSubCategory)
      })
      commit('setSelectedSubCatState', selectedSubCats)
      // If there are no categories outside first layer categories
      if(subCategories.length == 0){
        // Set selected sub categories to empty
        commit('setSelectedSubCatState', [])
      }
      commit('setSubCategoriesState', functions.groupBy(uniqueSubCategories, 'Parent'))
    }
  },
  getters: {
    selectedSubCategories: state => state.selectedSubCategories,
    subCategoriesInSelectedCategories: state => state.subCategories,
  }
}
export default subCategories